import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  uploadedPictures: {
    images: [],
    coverImages: [],
  },
};

const picturesSlice = createSlice({
  name: 'pictures',
  initialState,
  reducers: {
    addPicture(state, { payload }) {
      const { massName, photo, data } = payload;
      if (!state.uploadedPictures[massName]) state.uploadedPictures[massName] = [];
      state.uploadedPictures[massName].push({ ...data, ...photo });
    },
    deletePicture(state, { payload }) {
      const { massName, id } = payload;
      state.uploadedPictures[massName] = state.uploadedPictures[massName].filter(item => item.file_id !== id);
    },
    replacePicture(state, { payload }) {
      const { massName, photo } = payload;
      const idx = state.uploadedPictures[massName].findIndex(item => item.file_id === photo.file_id);
      if (idx !== -1) state.uploadedPictures[massName][idx] = photo;
    },
    clearCoverPictures(state) {
      state.uploadedPictures.coverImages = initialState.uploadedPictures.coverImages;
    },
    clearPictures(state) {
      state.uploadedPictures = initialState.uploadedPictures;
    },
    fillPicturesStore(state, { payload }) {
      state.uploadedPictures = payload;
    },
    changeOrderOfPictures(state, { payload }) {
      const { dropItem, dragItem } = payload;
      const images = state.uploadedPictures.images || [];
      const coverImages = state.uploadedPictures.coverImages || [];
      if (!dropItem) return;

      const shuffleImages = item => {
        if (item.name === dragItem.name && item.createDate === dragItem.createDate) return dropItem;
        if (item.name === dropItem.name && item.createDate === dropItem.createDate) return dragItem;
        return item;
      };

      const shuffleMass = images.map(shuffleImages);
      const shuffleCoverMass = coverImages.map(shuffleImages);

      state.uploadedPictures = { images: shuffleMass, coverImages: shuffleCoverMass };
    },
  },
});

export const {
  addPicture,
  deletePicture,
  replacePicture,
  clearPictures,
  clearCoverPictures,
  fillPicturesStore,
  changeOrderOfPictures,
} = picturesSlice.actions;
export default picturesSlice.reducer;
